var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrashBinActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 36,
    height: 36,
    rx: 4,
    fill: "#326FAE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7568 11.9395H24.6012V26.794C24.6012 28.2142 23.45 29.3655 22.0298 29.3655H13.3283C11.9081 29.3655 10.7568 28.2142 10.7568 26.794V11.9395Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7566 11.457C11.0228 11.457 11.2387 11.6729 11.2387 11.9392V26.7938C11.2387 27.9476 12.1741 28.8831 13.328 28.8831H22.0295C23.1834 28.8831 24.1188 27.9476 24.1188 26.7938V11.9392C24.1188 11.6729 24.3347 11.457 24.6009 11.457C24.8672 11.457 25.0831 11.6729 25.0831 11.9392V26.7938C25.0831 28.4802 23.716 29.8473 22.0295 29.8473H13.328C11.6415 29.8473 10.2744 28.4802 10.2744 26.7938V11.9392C10.2744 11.6729 10.4903 11.457 10.7566 11.457Z",
    fill: "#326FAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6023 14.4873C14.8685 14.4873 15.0844 14.7032 15.0844 14.9694V26.3342C15.0844 26.6005 14.8685 26.8164 14.6023 26.8164C14.336 26.8164 14.1201 26.6005 14.1201 26.3342V14.9694C14.1201 14.7032 14.336 14.4873 14.6023 14.4873Z",
    fill: "#326FAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6784 14.4873C17.9447 14.4873 18.1606 14.7032 18.1606 14.9694V26.3342C18.1606 26.6005 17.9447 26.8164 17.6784 26.8164C17.4122 26.8164 17.1963 26.6005 17.1963 26.3342V14.9694C17.1963 14.7032 17.4122 14.4873 17.6784 14.4873Z",
    fill: "#326FAE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7556 14.4873C21.0219 14.4873 21.2377 14.7032 21.2377 14.9694V26.3342C21.2377 26.6005 21.0219 26.8164 20.7556 26.8164C20.4893 26.8164 20.2734 26.6005 20.2734 26.3342V14.9694C20.2734 14.7032 20.4893 14.4873 20.7556 14.4873Z",
    fill: "#326FAE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.73633 10.4235C8.73633 10.1573 8.95219 9.94141 9.21847 9.94141H26.1394C26.4057 9.94141 26.6215 10.1573 26.6215 10.4235C26.6215 10.6898 26.4057 10.9057 26.1394 10.9057H9.21847C8.95219 10.9057 8.73633 10.6898 8.73633 10.4235Z",
    fill: "#326FAE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7354 7.39328C13.7354 7.127 13.9512 6.91113 14.2175 6.91113H21.1397C21.406 6.91113 21.6218 7.127 21.6218 7.39328V8.90858C21.6218 9.17486 21.406 9.39073 21.1397 9.39073C20.8734 9.39073 20.6575 9.17486 20.6575 8.90858V7.87542H14.6996V8.90858C14.6996 9.17486 14.4838 9.39073 14.2175 9.39073C13.9512 9.39073 13.7354 9.17486 13.7354 8.90858V7.39328Z",
    fill: "#326FAE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBinActive);
export default __webpack_public_path__ + "static/media/trash-bin-active.7942c5b4d09af70077354e333ee86b33.svg";
export { ForwardRef as ReactComponent };